<template>
  <section class="innerpages animate__animated animate__slideInRight">
    <div class="container ">
      <div class="row">
        <div class="col-md-12 listPage">
          <h1 class="text-truncate" :title="activeItem.label">{{activeItem.label}}</h1>
          <div class="card ">
            <b-table
              :items="nonZeroData"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              sort-icon-right
              responsive="sm"
              show-empty
              @row-clicked="openList"
              tbody-tr-class="dataDivider"
              >
              <template v-slot:empty="scope">
                <h5 class="noData">No Data</h5>
              </template>
              <template v-slot:cell(count)="data">
                <i style="font-style:normal">{{ data.item.is_amount ? Number(data.value).toLocaleString('en-IN') : data.value  }} 
                  <span v-if="!data.item.is_amount" class="icon-arrow">
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve">
                        <polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718 "></polygon>
                    </svg>
                  </span>
                </i>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
   data(){
    return {
      sortBy: 'count',
      sortDesc: false,
    }
  },
  methods: {
    openList(item){
      if(item.data && item.data.length>0)
      {
      let activeItem = {label: this.activeItem.label, labelNo:3, itemType: this.activeItem.itemType, itemId: this.activeItem.itemId, statudId:item.status_id, data: item.data}
      this.$store.dispatch('setSubStatusActiveItem', activeItem);
      this.$router.push("/details");
      }
      else
      {
        let url="";
        if (this.activeTitle === 'Qualification Report') {
          url = `/leads/for/${this.activeItem.itemType}/${this.activeItem.itemId}/status/${this.activeItem.project_id}/from/${this.fromDate}/upto/${this.toDate}?lead_type=${item.lead_type}`
          this.$router.push(url);
        } else if (this.activeTitle === 'Call Activity Report') {
          this.$router.push({
              path: `/leads/for/${this.activeItem.itemType}/${this.activeItem.itemId}/status/${this.activeItem.project_id}/from/${this.fromDate}/upto/${this.toDate}`,
              query: {
                ...this.$route.query,
                lead_type: item.lead_type
              }
            });
        } else if (this.activeTitle === 'Backlog Report') {
            this.$router.push({
              path: `/leads/for/${this.activeItem.itemType}/${this.activeItem.itemId}`,
              query: {
                ...this.$route.query,
                status_id: item.status_id
              }
            });
          } else if (this.activeTitle === 'Call Activity Report') {
            this.$router.push({
              path: `/leads/for/${this.activeItem.itemType}/${this.activeItem.itemId}`,
              query: {
                ...this.$route.query,
                lead_type: item.lead_type
              }
            });
          }else if (this.activeTitle === 'ROI User Wise Report') {
            if (!item.is_amount) {
              this.$router.push({
              path: `/leads/for/${this.activeItem.itemType}/${this.activeItem.itemId}`,
              query: {
                ...this.$route.query,
                lead_type: item.lead_type
              }
            });
            }
          }else if (this.activeTitle === 'ROI Source Wise Report') {
            if (!item.is_amount) {
              this.$router.push({
              path: `/leads/for/${this.activeItem.itemType}/${this.activeItem.itemId}`,
              query: {
                ...this.$route.query,
                lead_type: item.lead_type
              }
            });
            }
          }else {
          url = `/leads/for/${this.activeItem.itemType}/${this.activeItem.itemId}/status/${item.status_id}/from/${this.fromDate}/upto/${this.toDate}`
          this.$router.push(url);
        }
      }
    }
  },
  computed: {
    activeItem(){
      return this.$store.getters.activeItem;
    },
    activeTitle(){
      return this.$store.getters.activeTitle;
    },
    nonZeroData() {
    return (this.activeItem.data || []).filter(a => {
      if (!a.count) return false;
      if (typeof a.count === 'number') {
        return a.count > 0;
      }
      if (typeof a.count === 'string') {
        const match = a.count.match(/^(\d+)\s\(\d+\)$/);
        if (!match) return false;

        return parseInt(match[1], 10) > 0;
      }

      return false;
    });
  },
    fields() {
      return [
        {
          key: ['Qualification Report', 'Call Activity Report', 'ROI User Wise Report', 'ROI Source Wise Report'].includes(this.$store.getters.activeTitle) ? 'name' : 'status',
          sortable: true,
          class: 'headingClass',
        },
        {
          key: 'count',
          sortable: true,
        },
      ];
  },
    defaultDates(){
      return this.$store.getters.defaultDates;
    },
    fromDate(){
      return this.defaultDates.from;
    },
    toDate(){
      return this.defaultDates.upto;
    }
  }
}
</script>